import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorHandlers, IdentityResponse, InitialIdentityState, WorkflowRequest } from '../../../types';
import { identityApi } from '../../requests';
export const generateWorkflowId = createAsyncThunk<
  IdentityResponse,
  WorkflowRequest & ErrorHandlers,
  {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    dispatch: any;
    extra: {
      BASE_API_URL: string;
    };
    state: InitialIdentityState;
  }
>('commerceIdentity/generateWorkflowId', async ({ username, workflowType, errorHandlers }, { extra }) => {
  const res = await identityApi.generateWorkflowId({
    username,
    workflowType,
    errorHandlers,
    baseUrl: extra.BASE_API_URL,
  });
  return res;
});
